import { Navigate } from "react-router-dom";

import useTitle from "hooks/useTitle";
import useMFA from "hooks/useMFA";
import SpaceliftLoader from "components/loading/SpaceliftLoader";

// RedirectPage is used by backend, if they need to redirect to app based on localStorage "redirectTo" value
const RedirectPage = () => {
  useTitle("Redirecting...");

  const { shouldUseMFA, shouldRegisterSecurityKey } = useMFA();

  const redirectTo = localStorage.getItem("redirectTo") || "/";

  if (shouldRegisterSecurityKey) {
    return <Navigate to="/enable_mfa" replace />;
  }

  if (shouldUseMFA) {
    return <Navigate to="/mfa" replace />;
  }

  if (redirectTo) {
    localStorage.removeItem("redirectTo");

    return <Navigate to={redirectTo} replace />;
  }

  return <SpaceliftLoader />;
};

export default RedirectPage;
